import _ from "lodash"

export const constructImageURL = (image) => `${process.env.REACT_APP_ASSET_URL}/${image}`

export const generateFallbackText = (text) => _.upperFirst(text).trim().split(" ").map(t => t[0]).join("")